import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function usePageType() {
  const { pathname } = useLocation();

  const isPeoplePage = useMemo(
    () => pathname.startsWith('/people'),
    [pathname]
  );
  const isCompanyPage = useMemo(
    () => pathname.startsWith('/company'),
    [pathname]
  );

  return useMemo(() => {
    return { isPeoplePage, isCompanyPage };
  }, [isPeoplePage, isCompanyPage]);
}
